import * as React from 'react'
import cn from 'classnames'
import Image from 'next/image'

import birthday from './birthday.svg'

import styles from './Occasion.module.css'

type OccasionProps = {
  label: string
  loading: boolean
} & IconProps

type IconProps = {
  icon: string
}

const Icon: React.FC<IconProps> = ({ icon }) => {
  const src = icon === 'birthday' ? birthday : icon

  return (
    <div className={styles.iconContainer}>
      <Image
        className={styles.icon}
        src={src}
        width={24}
        height={24}
        alt="occasion"
      />
    </div>
  )
}

const Occasion: React.FC<OccasionProps> = ({ icon, label, loading }) => {
  if (loading) return null

  return (
    <div
      className={cn(styles.occationContainer, {
        [styles.labelSmall]: !!icon,
        [styles.labelBig]: !icon,
      })}
    >
      {icon && <Icon icon={icon} />}
      {label}
    </div>
  )
}

export default Occasion
